module.exports = {"654226100":"和布克赛尔镇","654226101":"和什托洛盖镇","654226200":"夏孜盖乡","654226201":"铁布肯乌散乡","654226202":"查干库勒乡","654226203":"巴音傲瓦乡","654226204":"莫特格乡","654226205":"查和特乡","654226400":"伊克乌图布拉格牧场","654226401":"那仁和布克牧场","654226402":"巴尕乌图布拉格牧场","654226403":"布斯屯格牧场","654226500":"兵团一八四团","654226501":"新疆屯南煤业有限责任公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654226.json
// module id = 3285
// module chunks = 0